module.exports = __webpack_public_path__ + "img/ANC-alt.0295d164.svg";